const _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"WRs2R8e6d9No7cHykbNw6"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["moonsworth-site@moonsworthllc"]={id:"WRs2R8e6d9No7cHykbNw6"};
      